module.exports = __webpack_public_path__ + "static/media/info-white.b86fb9eb.svg";